import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<"loading" | "ok" | "unauth" | "nonadmin">("loading");

  useEffect(() => {
    let active = true;
    const check = async (userId: string | null) => {
      if (!userId) { if (active) setState("unauth"); return; }
      const { data } = await supabase.from("user_roles").select("role").eq("user_id", userId).eq("role", "admin").maybeSingle();
      if (!active) return;
      setState(data ? "ok" : "nonadmin");
    };
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      check(session?.user?.id ?? null);
    });
    supabase.auth.getSession().then(({ data: { session } }) => check(session?.user?.id ?? null));
    return () => { active = false; subscription.unsubscribe(); };
  }, []);

  if (state === "loading") return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (state === "unauth") return <Navigate to="/auth" replace />;
  if (state === "nonadmin") return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-xl font-semibold text-foreground">Access denied</h1>
        <p className="text-muted-foreground text-sm">Your account is signed in but not yet an admin. Ask an existing admin to invite you, or — if this is the first account — promote yourself by running the SQL noted in the build instructions.</p>
        <button onClick={() => supabase.auth.signOut()} className="text-primary hover:underline text-sm">Sign out</button>
      </div>
    </div>
  );
  return <>{children}</>;
}
